const regexp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
export default typeof navigator !== 'undefined' && regexp.test(navigator.userAgent)
